import { UPDATE_DIALOG_FOCUS_AREAS_SHAPE_ERROR } from './index';

export const updateDialogFocusAreasShapeErrorAction = (focus_areas_shape_error) => ({
    type: UPDATE_DIALOG_FOCUS_AREAS_SHAPE_ERROR,
    focus_areas_shape_error
});